export const formatDate = (date) => {
  const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
  const a = new Date(date);
  return `${months[a.getMonth()]} ${a.getDate()}`
};